import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Mi venis al la mond’ por vidi sunon…</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Mi venis al la mond’ por vidi Sunon <br/>
        Sur blua horizont’, <br/>
        Mi venis al la mond’ por vidi Sunon <br/>
        De l’ supro de la mont’.
      </p>

      <p class="poem-block mb-3">
        Mi venis al la mond’ por vidi maron <br/>
        Sen limo kaj sen fin’. <br/>
        De l’ tuta mondo mi forprenis baron <br/>
        Kaj plenposedas ĝin!
      </p>

      <p class="poem-block mb-3">
        Mi venkis la tenebron kaj forgeson <br/>
        Per vol’ de l’ fantazi’. <br/>
        Mi kantas por esprimi la impreson <br/>
        De belvizi’.
      </p>

      <p class="poem-block mb-3">
        Se pro dolor’ ekvibris mia nervo, <br/>
        Resonis via am’! <br/>
        Kiu egalas min en poezia vervo? <br/>
        Neniu. Neniam.
      </p>

      <p class="poem-block mb-3">
        Mi venis al la mond’ por vidi Sunon, <br/>
        Kaj se eknigros tag’, <br/>
        Mi kantos… Jes, prikantos mi la Sunon <br/>
        Malgraŭ la plag’!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Konstantin Balmont'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;